import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaReabilitacaoRequest } from './types';

// ACTIONS
import {
	consultaReabilitacaoSuccess,
	consultaReabilitacaoFailure,
} from './actions';

function* consultaReabilitacao(request: ReducerAction) {
	const { payload }: { payload: ConsultaReabilitacaoRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/pesquisa/reabilitacao-cassacao`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaReabilitacaoSuccess({ response, request: payload }));
	} else {
		yield put(
			consultaReabilitacaoFailure({
				response: response.data,
				request: payload,
			}),
		);
	}
}

export default all([
	takeLatest(Types.CONSULTA_REABILITACAO, consultaReabilitacao),
]);
